<div class="report-problem-wrapper" (click)="openWindow()">
  <span class="text">Provide Feedback</span>
</div>
